import React from "react";
import { MedicaidLeadStatus } from "modules/medicaid/types";
import type {
  MedicaidLeadSummaryActionProps,
  MedicaidLeadSummaryBackButtonProps,
  MedicaidLeadSummaryMainActionProps,
} from "./types";
import TabbedButton, { TabbedButtonType } from "components/TabbedButton";

import styles from "./styles.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const MedicaidLeadSummaryBackButton = ({
  onBack,
}: MedicaidLeadSummaryBackButtonProps) => (
  <div className={cx("medicaid-lead-summary-back-button")}>
    <TabbedButton
      onClick={onBack}
      label="Back to interview"
      style={TabbedButtonType.SECONDARY}
    />
  </div>
);

const MedicaidLeadSummaryMainAction = ({
  medicaidLeadStatus,
  onConfirmSummary,
  isPublicLead,
}: MedicaidLeadSummaryMainActionProps) => {
  if (isPublicLead) {
    return (
      <div className={cx("medicaid-lead-summary-main-action")}>
        <TabbedButton onClick={onConfirmSummary} label="Submit" />
      </div>
    );
  }
  switch (medicaidLeadStatus) {
    case MedicaidLeadStatus.LeadAccepted:
    case MedicaidLeadStatus.LeadRejected:
    case MedicaidLeadStatus.ReadyForPartner: {
      return (
        <div className={cx("medicaid-lead-summary-main-action")}>
          <TabbedButton
            onClick={onConfirmSummary}
            label="Asset protection analysis"
          />
        </div>
      );
    }
    case MedicaidLeadStatus.AwaitingAttorneyRequest: {
      return (
        <div className={cx("medicaid-lead-summary-main-action")}>
          <TabbedButton onClick={onConfirmSummary} label="Submit to Law Firm" />
        </div>
      );
    }
    case MedicaidLeadStatus.InterviewInProgress: {
      return (
        <div className={cx("medicaid-lead-summary-main-action")}>
          <TabbedButton
            onClick={onConfirmSummary}
            label="Get your asset protection analysis!"
          />
        </div>
      );
    }
    default:
      return null;
  }
};

const MedicaidLeadSummaryActions = ({
  medicaidLeadStatus,
  onBack,
  onConfirmSummary,
  isEditable,
  isPublicLead,
}: MedicaidLeadSummaryActionProps) => (
  <div className={cx("medicaid-lead-summary-actions")}>
    {onBack && isEditable && <MedicaidLeadSummaryBackButton onBack={onBack} />}
    <MedicaidLeadSummaryMainAction
      medicaidLeadStatus={medicaidLeadStatus}
      onConfirmSummary={onConfirmSummary}
      isPublicLead={isPublicLead}
    />
  </div>
);

export default MedicaidLeadSummaryActions;
